import { categories } from '@/mocks/campusData';

export default function Footer() {
  return (
    <footer className="bg-[#3a2a1c] text-stone-200">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" aria-label="校园反转社 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-600 text-white">
                <i className="ri-newspaper-line text-lg" />
              </span>
              <span className="leading-tight">
                <span className="block font-editorial text-lg font-black tracking-wide text-white">
                  校园反转社
                </span>
                <span className="block text-[11px] text-stone-400">吃瓜·求证·追真相</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-300">
              专注校园热点反转与辟谣求真，把爆料、发酵、反转、复盘一路追完整。吃瓜不烂尾，求真守底线。
            </p>
            <div className="mt-5 flex flex-wrap gap-2 text-xs text-stone-300">
              <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-3 py-1">
                <i className="ri-mail-line text-red-400" /> contact@xiaoyuanfanzhuan.example
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-3 py-1">
                <i className="ri-time-line text-red-400" /> 每日 8:00–24:00 在线
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            <div>
              <h3 className="text-sm font-bold text-white">吃瓜栏目</h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                {categories.map((c) => (
                  <li key={c.key}>
                    <a href="#feed" className="text-stone-400 transition hover:text-white">
                      {c.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-bold text-white">站点导航</h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><a href="#timeline" className="text-stone-400 transition hover:text-white">反转现场</a></li>
                <li><a href="#review" className="text-stone-400 transition hover:text-white">真相复盘</a></li>
                <li><a href="#principle" className="text-stone-400 transition hover:text-white">内容原则</a></li>
                <li><a href="#about" className="text-stone-400 transition hover:text-white">关于我们</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-bold text-white">帮助支持</h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><a href="#faq" className="text-stone-400 transition hover:text-white">吃瓜指南 FAQ</a></li>
                <li><a href="#contact" className="text-stone-400 transition hover:text-white">爆料投稿</a></li>
                <li><a href="#contact" className="text-stone-400 transition hover:text-white">意见反馈</a></li>
                <li><a href="#principle" className="text-stone-400 transition hover:text-white">侵权与投诉处理</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-stone-400 sm:flex-row sm:items-center">
          <p>© 2026 校园反转社 · 内容仅基于公开可查信息整理，不扩散涉及真实个人隐私的伤害性素材。</p>
          <a href="#top" className="inline-flex items-center gap-1 whitespace-nowrap transition hover:text-white">
            返回顶部 <i className="ri-arrow-up-line" />
          </a>
        </div>
      </div>
    </footer>
  );
}